import React from 'react'
import { SecurityQuestions } from './SecurityQuestions'
import { useLoginToExistingAccountWithVerificationFlowMutation } from './SecurityQuestions.codegen'
import { transitionAppStateToLoggedIn } from '../SessionHelpers'
import { useLoginContext } from '../login/LoginContext'
import { observer } from 'mobx-react'
import { useOrganisation } from 'front-end/src/public-api/hooks/useOrganisation'

const useLoginToExistingAccountWithVerificationFlow = () => {
  const ctx = useLoginContext()

  const [fetch] = useLoginToExistingAccountWithVerificationFlowMutation()
  return async () => {
    const { data } = await fetch({
      variables: {
        accountName: ctx.userIdentity,
        additionalData: {
          ...ctx.pickUserAdditionalData(),
          password: ctx.password
        },
        questionAnswers: ctx.securityQuestions,
        verificationData: ctx.verificationData!
      }
    })

    if (data?.loginToExistingAccountWithVerificationFlow?.user) {
      return data.loginToExistingAccountWithVerificationFlow
    }
    return null
  }
}

export const AskSecurityQuestionsAndLoginWithVerificationStep: React.FC =
  observer(() => {
    const { data: orgData } = useOrganisation()
    const loginToExistingAccountWithVerificationFlow =
      useLoginToExistingAccountWithVerificationFlow()
    const submit = async (): Promise<boolean> => {
      const session = await loginToExistingAccountWithVerificationFlow()
      if (session) {
        transitionAppStateToLoggedIn(session, orgData?.organisation)
        return true
      }
      return false
    }

    return <SecurityQuestions submit={submit} />
  })

AskSecurityQuestionsAndLoginWithVerificationStep.displayName =
  'AskSecurityQuestionsAndLoginWithVerificationStep'
